// import { useLocation } from "@reach/router";
import { Group, Text } from "@mantine/core";
import { navigate } from "gatsby";
import React, { useEffect } from 'react';
import useLanguageNavigator from "../hooks/useLanguageNavigator";
import { availableLanguages } from "./api";

const LangBar = () => {
    const { lang, updateLanguage } = useLanguageNavigator(availableLanguages)
    const setLang = (lang: string) => {
        updateLanguage(lang)
        handleLanguageChange(lang)
    }
    const handleLanguageChange = (newLanguage: string, shouldNavigate = true) => {
        if (lang !== newLanguage) {
            const currentPath = window.location.pathname;
            const languagePattern = /^\/[a-z]{2}(\/|$)/;
            let newPath;
            if (newLanguage === "en") { // Remove any existing language prefix
                newPath = currentPath.replace(languagePattern, '/');
                newPath = newPath.replace('//', '/'); // Ensure no double slashes
            } else { // Replace existing language prefix with new one or add it if absent
                newPath = currentPath.replace(languagePattern, `/${newLanguage}/`);
                if (newPath === currentPath) {
                    newPath = `/${newLanguage}${currentPath}`;
                }
                newPath = newPath.replace('//', '/'); // Ensure no double slashes
            }
            step23(newPath, newLanguage)
        }
    };
    const step23 = (newPath: string, language: string) => {
        const path = window.location.pathname
        const html = document.documentElement;
        const cl = html.getAttribute("lang")
        const cd = html.getAttribute("dir")
        if (language === "ar") {
            if(cd !== "rtl") html.setAttribute("dir", "rtl");
            if(cl !== "ar") html.setAttribute("lang", "ar");
        } else {
            if(cd !== "ltr") html.setAttribute("dir", "ltr");
            if(cl !== language) html.setAttribute("lang", language);
        }
        updateLanguage(language);
        if (path !== newPath) {
            (navigate as unknown as (path: string, options?: { replace?: boolean }) => void)(newPath, { replace: true });
        }
    }
    useEffect(() => {
        const currentPath = window.location.pathname;
        const pathSegments = currentPath.split('/');
        let languageCode = pathSegments[1];
        const languagePattern = /^\/[a-z]{2}(\/|$)/;
        const hasLanguagePrefix = languagePattern.test(currentPath)
        let newPath = ''
        if (languageCode.length > 2 || languageCode.length === 0) {languageCode = "en"} // case 1, 3
        if (!availableLanguages.includes(languageCode)){languageCode = "en"} // case 5
        if (hasLanguagePrefix && languageCode === "en") { 
            newPath = currentPath.replace(/^\/en/, '/')
            newPath = newPath.replace('//', '/')
        }
        else if (!hasLanguagePrefix && languageCode !== "en") { newPath = `/${languageCode}${currentPath}`;} 
        else if (hasLanguagePrefix && languageCode !== "en") { 
            let newPath2 = currentPath.replace(languagePattern, '/');
            newPath2 = newPath2.replace('//', '/'); // Ensure no double slashes
            newPath = `/${languageCode}${newPath2}`;
        } 
        else if (!hasLanguagePrefix && languageCode === "en") { newPath = currentPath } 
        step23(newPath, languageCode)
    }, [])
    return (
    // <BtnMariam name={language == "en" ? 'ع' : "En"} mb={0} onclick={ () => language == "en" ? setLang('ar') : setLang('en') } />
    <Group justify="flex-end" m={12}>
        <Text c={"#c9a365"} fw={'bold'} fz={22} style={{ cursor: "pointer" }} onClick={() => lang == "en" ? setLang('ar') : setLang('en')} >{lang == "en" ? 'عربى' : "En"}</Text>
    </Group>
    )
}

export default LangBar